import { useState, useEffect, useRef } from "react";
import { settingsAPI } from "../../api";
import { imgUrl } from "../../api";
import toast from "react-hot-toast";
import "./Configuracion.css";

const TABS = [
  { id: "identidad", label: "🏢 Identidad", icon: "🏢" },
  { id: "contacto",  label: "📍 Contacto",  icon: "📍" },
  { id: "redes",     label: "📱 Redes",     icon: "📱" },
  { id: "portal",    label: "🌐 Portal",    icon: "🌐" },
  { id: "seo",       label: "🔍 SEO & Analytics", icon: "🔍" },
  { id: "notifs",    label: "📧 Notificaciones", icon: "📧" },
];

export default function Configuracion() {
  const [tab, setTab]       = useState("identidad");
  const [form, setForm]     = useState({});
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [logoPreview, setLogoPreview]     = useState(null);
  const [faviconPreview, setFaviconPreview] = useState(null);
  const [heroPreview, setHeroPreview]     = useState(null);
  const logoRef    = useRef();
  const faviconRef = useRef();
  const heroRef    = useRef();

  useEffect(() => {
    settingsAPI.obtener()
      .then((r) => { setForm(r.data.data); setCargando(false); })
      .catch(() => { toast.error("Error cargando configuración"); setCargando(false); });
  }, []);

  const set = (key, val) => setForm((f) => ({ ...f, [key]: val }));

  const guardar = async () => {
    setGuardando(true);
    try {
      await settingsAPI.guardar(form);
      toast.success("Configuración guardada ✓");
    } catch {
      toast.error("Error guardando");
    } finally {
      setGuardando(false);
    }
  };

  const subirImagen = async (file, tipo) => {
    try {
      const res = await settingsAPI.subirLogo(file, tipo);
      const url = res.data.url;
      if (tipo === "favicon") { set("favicon_url", url); setFaviconPreview(URL.createObjectURL(file)); }
      else if (tipo === "hero") { set("hero_image_url", url); setHeroPreview(URL.createObjectURL(file)); }
      else { set("logo_url", url); setLogoPreview(URL.createObjectURL(file)); }
      toast.success("Imagen subida ✓");
    } catch {
      toast.error("Error subiendo imagen");
    }
  };

  if (cargando) return <div className="spinner" style={{ marginTop: "6rem" }} />;

  return (
    <div className="config-page fade-in">
      <div className="page-header">
        <div>
          <h1 className="heading-serif page-title">Configuración</h1>
          <p style={{ color: "var(--color-text-muted)", fontSize: ".9rem" }}>
            Personaliza la identidad y datos de tu sitio web
          </p>
        </div>
        <button className="btn btn-accent" onClick={guardar} disabled={guardando}>
          {guardando ? "Guardando…" : "💾 Guardar cambios"}
        </button>
      </div>

      {/* Tabs */}
      <div className="config-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`config-tab ${tab === t.id ? "active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            <span className="tab-icon">{t.icon}</span>
            <span className="tab-label">{t.label.split(" ").slice(1).join(" ")}</span>
          </button>
        ))}
      </div>

      <div className="config-body card">

        {/* ── IDENTIDAD ── */}
        {tab === "identidad" && (
          <div className="config-section">
            <h2 className="config-section-title">Identidad de la empresa</h2>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Nombre de la inmobiliaria *</label>
                <input className="form-input" value={form.site_name || ""}
                  onChange={(e) => set("site_name", e.target.value)}
                  placeholder="InmobiliariaPlus" />
              </div>
              <div className="form-group">
                <label className="form-label">Slogan / Tagline</label>
                <input className="form-input" value={form.site_tagline || ""}
                  onChange={(e) => set("site_tagline", e.target.value)}
                  placeholder="Tu aliado de confianza en bienes raíces" />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Descripción breve</label>
              <textarea className="form-textarea" rows={2} value={form.site_description || ""}
                onChange={(e) => set("site_description", e.target.value)}
                placeholder="Describe en 1-2 líneas a qué se dedica la inmobiliaria" />
            </div>

            {/* Logo */}
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Logo</label>
                <div className="upload-preview-box">
                  {(logoPreview || form.logo_url) ? (
                    <img src={logoPreview || imgUrl(form.logo_url)} alt="Logo" className="logo-preview" />
                  ) : (
                    <div className="upload-placeholder">🏠<br /><small>Sin logo</small></div>
                  )}
                  <input ref={logoRef} type="file" accept="image/*" style={{ display: "none" }}
                    onChange={(e) => e.target.files[0] && subirImagen(e.target.files[0], "logo")} />
                  <button className="btn btn-ghost btn-sm" type="button"
                    onClick={() => logoRef.current?.click()}>
                    📁 Cambiar logo
                  </button>
                  {form.logo_url && (
                    <button className="btn btn-ghost btn-sm" type="button"
                      onClick={() => { set("logo_url", ""); setLogoPreview(null); }}>
                      ✕ Quitar
                    </button>
                  )}
                </div>
                <p className="form-hint">PNG o SVG con fondo transparente recomendado</p>
              </div>

              <div className="form-group">
                <label className="form-label">Favicon</label>
                <div className="upload-preview-box">
                  {(faviconPreview || form.favicon_url) ? (
                    <img src={faviconPreview || imgUrl(form.favicon_url)} alt="Favicon"
                      style={{ width: 64, height: 64, objectFit: "contain" }} />
                  ) : (
                    <div className="upload-placeholder">🔖<br /><small>Sin favicon</small></div>
                  )}
                  <input ref={faviconRef} type="file" accept="image/*" style={{ display: "none" }}
                    onChange={(e) => e.target.files[0] && subirImagen(e.target.files[0], "favicon")} />
                  <button className="btn btn-ghost btn-sm" type="button"
                    onClick={() => faviconRef.current?.click()}>
                    📁 Cambiar
                  </button>
                </div>
                <p className="form-hint">PNG cuadrado 32×32 o 64×64 px</p>
              </div>
            </div>

            {/* Colores */}
            <h3 className="config-subsection-title">Colores del sitio</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Color primario</label>
                <div className="color-picker-row">
                  <input type="color" className="color-input" value={form.color_primary || "#1B2B4B"}
                    onChange={(e) => set("color_primary", e.target.value)} />
                  <input className="form-input" value={form.color_primary || "#1B2B4B"}
                    onChange={(e) => set("color_primary", e.target.value)}
                    placeholder="#1B2B4B" style={{ flex: 1 }} />
                </div>
                <p className="form-hint">Color principal (navbar, títulos, botones)</p>
              </div>
              <div className="form-group">
                <label className="form-label">Color acento</label>
                <div className="color-picker-row">
                  <input type="color" className="color-input" value={form.color_accent || "#C9A96E"}
                    onChange={(e) => set("color_accent", e.target.value)} />
                  <input className="form-input" value={form.color_accent || "#C9A96E"}
                    onChange={(e) => set("color_accent", e.target.value)}
                    placeholder="#C9A96E" style={{ flex: 1 }} />
                </div>
                <p className="form-hint">Color acento (botones CTA, destacados)</p>
              </div>
            </div>

            <div className="color-preview">
              <div className="color-chip" style={{ background: form.color_primary || "#1B2B4B" }}>
                <span>Primario</span>
              </div>
              <div className="color-chip" style={{ background: form.color_accent || "#C9A96E" }}>
                <span>Acento</span>
              </div>
            </div>
          </div>
        )}

        {/* ── CONTACTO ── */}
        {tab === "contacto" && (
          <div className="config-section">
            <h2 className="config-section-title">Información de contacto</h2>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Dirección línea 1</label>
                <input className="form-input" value={form.contact_address || ""}
                  onChange={(e) => set("contact_address", e.target.value)}
                  placeholder="Calle Principal #123" />
              </div>
              <div className="form-group">
                <label className="form-label">Dirección línea 2</label>
                <input className="form-input" value={form.contact_address_2 || ""}
                  onChange={(e) => set("contact_address_2", e.target.value)}
                  placeholder="Col. Centro, Córdoba, Ver." />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Teléfono</label>
                <input className="form-input" value={form.contact_phone || ""}
                  onChange={(e) => set("contact_phone", e.target.value)}
                  placeholder="(271) 123-4567" />
              </div>
              <div className="form-group">
                <label className="form-label">Email de contacto</label>
                <input type="email" className="form-input" value={form.contact_email || ""}
                  onChange={(e) => set("contact_email", e.target.value)}
                  placeholder="contacto@inmobiliaria.mx" />
              </div>
            </div>

            <h3 className="config-subsection-title">Horarios de atención</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Lunes a Viernes</label>
                <input className="form-input" value={form.contact_hours_weekdays || ""}
                  onChange={(e) => set("contact_hours_weekdays", e.target.value)}
                  placeholder="Lunes a Viernes: 9:00 – 18:00" />
              </div>
              <div className="form-group">
                <label className="form-label">Sábados</label>
                <input className="form-input" value={form.contact_hours_saturday || ""}
                  onChange={(e) => set("contact_hours_saturday", e.target.value)}
                  placeholder="Sábados: 9:00 – 14:00" />
              </div>
              <div className="form-group">
                <label className="form-label">Domingos</label>
                <input className="form-input" value={form.contact_hours_sunday || ""}
                  onChange={(e) => set("contact_hours_sunday", e.target.value)}
                  placeholder="Cerrado (dejar vacío para no mostrar)" />
              </div>
            </div>

            <h3 className="config-subsection-title">WhatsApp</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Número WhatsApp</label>
                <input className="form-input" value={form.whatsapp_number || ""}
                  onChange={(e) => set("whatsapp_number", e.target.value)}
                  placeholder="5212711234567" />
                <p className="form-hint">Formato internacional sin + ni espacios. Ej: 5212711234567</p>
              </div>
              <div className="form-group">
                <label className="form-label">Mensaje pre-llenado</label>
                <input className="form-input" value={form.whatsapp_message || ""}
                  onChange={(e) => set("whatsapp_message", e.target.value)}
                  placeholder="Hola, me interesa obtener información..." />
              </div>
            </div>
            {form.whatsapp_number && (
              <a
                href={`https://wa.me/${form.whatsapp_number}?text=${encodeURIComponent(form.whatsapp_message || "")}`}
                target="_blank" rel="noreferrer"
                className="btn btn-ghost btn-sm"
                style={{ color: "#25D366", width: "fit-content" }}
              >
                ✓ Probar enlace de WhatsApp
              </a>
            )}

            <h3 className="config-subsection-title">Ubicación en el mapa</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Latitud</label>
                <input className="form-input" value={form.contact_lat || ""}
                  onChange={(e) => set("contact_lat", e.target.value)}
                  placeholder="18.886840" />
              </div>
              <div className="form-group">
                <label className="form-label">Longitud</label>
                <input className="form-input" value={form.contact_lng || ""}
                  onChange={(e) => set("contact_lng", e.target.value)}
                  placeholder="-96.938591" />
              </div>
              <div className="form-group">
                <label className="form-label">Zoom del mapa</label>
                <input type="number" className="form-input" value={form.contact_map_zoom || "15"}
                  min="10" max="20"
                  onChange={(e) => set("contact_map_zoom", e.target.value)} />
              </div>
            </div>
            <p className="form-hint">
              💡 Pega las coordenadas de Google Maps. Ejemplo: <strong>18.886840, -96.938591</strong>
            </p>
          </div>
        )}

        {/* ── REDES SOCIALES ── */}
        {tab === "redes" && (
          <div className="config-section">
            <h2 className="config-section-title">Redes sociales</h2>
            <p style={{ color: "var(--color-text-muted)", marginBottom: "1.5rem", fontSize: ".9rem" }}>
              Deja vacío los que no uses — no aparecerán en el sitio.
            </p>

            {[
              { key: "social_facebook",  icon: "📘", label: "Facebook",  ph: "https://facebook.com/tuinmobiliaria" },
              { key: "social_instagram", icon: "📸", label: "Instagram", ph: "https://instagram.com/tuinmobiliaria" },
              { key: "social_tiktok",    icon: "🎵", label: "TikTok",    ph: "https://tiktok.com/@tuinmobiliaria" },
              { key: "social_youtube",   icon: "▶️", label: "YouTube",   ph: "https://youtube.com/@tuinmobiliaria" },
              { key: "social_twitter",   icon: "🐦", label: "X / Twitter", ph: "https://x.com/tuinmobiliaria" },
            ].map(({ key, icon, label, ph }) => (
              <div className="form-group social-row" key={key}>
                <label className="form-label">{icon} {label}</label>
                <input className="form-input" value={form[key] || ""}
                  onChange={(e) => set(key, e.target.value)}
                  placeholder={ph} type="url" />
              </div>
            ))}
          </div>
        )}

        {/* ── PORTAL ── */}
        {tab === "portal" && (
          <div className="config-section">
            <h2 className="config-section-title">Textos del portal público</h2>

            {/* Imagen hero */}
            <div className="form-group">
              <label className="form-label">Imagen de fondo del Hero</label>
              <p className="form-hint" style={{ marginBottom: ".75rem" }}>
                Recomendado: <strong>1920 × 1080 px</strong> (o mayor), formato JPG o WebP, peso máximo 2 MB.
                La imagen se mostrará con opacidad reducida sobre el color primario.
              </p>
              <div className="upload-preview-box hero-preview-box">
                {(heroPreview || form.hero_image_url)
                  ? <img src={heroPreview || imgUrl(form.hero_image_url)} alt="Hero" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "var(--radius)" }} />
                  : <div className="upload-placeholder">🖼️<br /><small>Sin imagen personalizada<br />(se usa color primario)</small></div>
                }
              </div>
              <div style={{ display: "flex", gap: ".75rem", marginTop: ".75rem" }}>
                <button type="button" className="btn btn-outline btn-sm" onClick={() => heroRef.current.click()}>
                  📁 Subir imagen
                </button>
                {(form.hero_image_url) && (
                  <button type="button" className="btn btn-ghost btn-sm"
                    onClick={() => { set("hero_image_url", ""); setHeroPreview(null); }}>
                    🗑 Quitar imagen
                  </button>
                )}
              </div>
              <input ref={heroRef} type="file" accept="image/*" style={{ display: "none" }}
                onChange={(e) => e.target.files[0] && subirImagen(e.target.files[0], "hero")} />
            </div>

            {/* Toggle WhatsApp */}
            <div className="form-group">
              <label className="form-label">Botón flotante de WhatsApp</label>
              <label className="toggle-row">
                <input type="checkbox"
                  checked={form.whatsapp_visible !== "false"}
                  onChange={(e) => set("whatsapp_visible", e.target.checked ? "true" : "false")} />
                <span className="toggle-label">
                  {form.whatsapp_visible !== "false" ? "✅ Visible en el portal" : "⛔ Oculto en el portal"}
                </span>
              </label>
              <p className="form-hint">Activa o desactiva el botón verde flotante de WhatsApp en todas las páginas.</p>
            </div>

            <div className="form-group">
              <label className="form-label">Título del Hero</label>
              <textarea className="form-textarea" rows={2} value={form.hero_title || ""}
                onChange={(e) => set("hero_title", e.target.value)}
                placeholder={"Encuentra tu\npropiedad ideal"} />
              <p className="form-hint">Puedes usar salto de línea para dividir el título en dos</p>
            </div>

            <div className="form-group">
              <label className="form-label">Subtítulo del Hero</label>
              <textarea className="form-textarea" rows={2} value={form.hero_subtitle || ""}
                onChange={(e) => set("hero_subtitle", e.target.value)}
                placeholder="Casas, departamentos, ranchos y más. Asesoría personalizada sin compromiso." />
            </div>

            <div className="form-group">
              <label className="form-label">Texto del botón CTA</label>
              <input className="form-input" value={form.hero_cta || ""}
                onChange={(e) => set("hero_cta", e.target.value)}
                placeholder="Buscar propiedades" />
            </div>
          </div>
        )}

        {/* ── SEO ── */}
        {tab === "seo" && (
          <div className="config-section">
            <h2 className="config-section-title">SEO y Analytics</h2>

            <div className="form-group">
              <label className="form-label">Meta descripción del sitio</label>
              <textarea className="form-textarea" rows={3} value={form.seo_description || ""}
                onChange={(e) => set("seo_description", e.target.value)}
                placeholder="Compra, venta y renta de propiedades en Córdoba y Veracruz..." />
              <p className="form-hint">
                Idealmente entre 120-160 caracteres.
                <span style={{ marginLeft: ".5rem", color: form.seo_description?.length > 160 ? "var(--color-error)" : "var(--color-text-muted)" }}>
                  {form.seo_description?.length || 0} / 160
                </span>
              </p>
            </div>

            <div className="form-group">
              <label className="form-label">Keywords (separadas por coma)</label>
              <input className="form-input" value={form.seo_keywords || ""}
                onChange={(e) => set("seo_keywords", e.target.value)}
                placeholder="bienes raices, casas en venta, Córdoba, Veracruz" />
            </div>

            <h3 className="config-subsection-title">Google Analytics</h3>
            <div className="form-group">
              <label className="form-label">Google Analytics ID</label>
              <input className="form-input" value={form.ga_id || ""}
                onChange={(e) => set("ga_id", e.target.value)}
                placeholder="G-XXXXXXXXXX" />
              <p className="form-hint">Formato: G-XXXXXXXXXX (GA4)</p>
            </div>

            <h3 className="config-subsection-title">Facebook Pixel</h3>
            <div className="form-group">
              <label className="form-label">Facebook Pixel ID</label>
              <input className="form-input" value={form.fb_pixel || ""}
                onChange={(e) => set("fb_pixel", e.target.value)}
                placeholder="123456789012345" />
            </div>
          </div>
        )}

        {/* ── NOTIFICACIONES ── */}
        {tab === "notifs" && (
          <div className="config-section">
            <h2 className="config-section-title">Notificaciones</h2>
            <p style={{ color: "var(--color-text-muted)", marginBottom: "1.5rem", fontSize: ".9rem" }}>
              Configura a dónde llegan los avisos cuando alguien llena el formulario de contacto.
            </p>

            <div className="form-group">
              <label className="form-label">Email(s) para recibir leads</label>
              <input type="email" className="form-input" value={form.notifications_email || ""}
                onChange={(e) => set("notifications_email", e.target.value)}
                placeholder="ventas@tuinmobiliaria.mx" />
              <p className="form-hint">
                Para múltiples destinatarios sepáralos con coma: correo1@mail.com, correo2@mail.com
              </p>
            </div>

            <div className="config-info-box">
              <span>ℹ️</span>
              <p>
                Los leads siempre quedan guardados en el apartado de <strong>Leads</strong> del panel.
                Este email es opcional y sirve como aviso inmediato.
              </p>
            </div>
          </div>
        )}

        {/* Botón guardar inferior */}
        <div className="config-footer">
          <button className="btn btn-accent" onClick={guardar} disabled={guardando}>
            {guardando ? "Guardando…" : "💾 Guardar cambios"}
          </button>
        </div>
      </div>
    </div>
  );
}
